module.exports = __webpack_public_path__ + "media/ascorbic-small.2eb530ce.mp4";